<template lang="pug">
el-drawer(
  title="新增專業人士"
  :visible.sync="drawer"
  :close-on-press-escape="false"
  :wrapperClosable="false"
  direction="rtl"
  :before-close="handleClose")
  .drawer.flex.column.gap-20
    .data.flex.column.align-stretch.gap-6
      .title 姓氏*
      el-input(v-model.trim="familyName", placeholder="請輸入專業人士姓氏")
    .data.flex.column.align-stretch.gap-6
      .title 名字*
      el-input(v-model.trim="givenName", placeholder="請輸入專業人士名字")
    .data.flex.column.align-stretch.gap-6
      .title Email*
      .alert.text-danger(v-if="origData && email !== origData?.email") 變更 email 需重新進行雙重驗證的綁定
      el-input(v-model.trim="email", placeholder="請輸入 Email")
    .data.flex.column.align-stretch.gap-6
      .title 登記館別*
      place-selector.place-input(
        :showAll="false"
        v-model="branch", @input="changeBranch")
    .data.flex.column.align-start.gap-6
      .title 照片*
      .photo.flex.column.align-start.gap-10
        el-button(type="primary", @click="upload") 點此上傳
        input(
          type="file", ref="upload",
          @input="changeFile")
        .preview.flex.align-end.gap-10(v-if="avatarPreview !== ''")
          img(:src="avatarPreview")
          .remove-icon.flex.align-center.justify-center.clickable(@click="removeAvatar")
            i.el-icon-close
    .data.flex.column.align-stretch.gap-6
      .title 職稱
      el-input(v-model.trim="position", placeholder="請輸入職稱")
    template(v-if="editMode")
      .data.flex.column.align-start.gap-6
        .title 專業人士帳號
        template(v-if="this.origData")
          el-button(type="danger", v-if="this.origData.enabled", @click="updateStatus(false)") 停用帳號
          el-button(type="success", v-else, @click="updateStatus(true)") 啟動帳號
    .data.flex.column.align-start.gap-6
      .title 簽名檔
      .photo.flex.column.align-start.gap-10
        el-button(type="primary", @click="uploadSignature") 點此上傳
        input(
          type="file", ref="uploadSignatureInput",
          @input="changeSignature")
        .preview.flex.align-end.gap-10(v-if="signaturePreview !== ''")
          img.preview-signature(:src="signaturePreview")
          .remove-icon.flex.align-center.justify-center.clickable(@click="removeSignature")
            i.el-icon-close
    .op.flex.align-center-justify-stretch.gap-10
      el-button.button(@click="cancel") 取消
      template(v-if="editMode")
        el-button.button(@click="save", type="primary", :disabled="!valid") 更新
      template(v-else)
        el-button.button(@click="save", type="primary", :disabled="!valid") 新增
</template>

<script>
import {
  newProfessional,
  updateProfessional,
  updateProfessionalStatus,
  createAvatar,
  createSignature,
} from '@/api/professionals';

export default {
  name: 'pro-editor',
  data() {
    return {
      origData: undefined,
      drawer: false,

      familyName: '',
      givenName: '',
      email: '',
      position: '',
      avatar: '',
      avatarPreview: '',
      file: undefined,
      branch: undefined,

      signature: '',
      signaturePreview: '',
      signatureFile: undefined,
    };
  },
  computed: {
    valid() {
      if (this.familyName === '') {
        return false;
      }
      if (this.givenName === '') {
        return false;
      }
      if (this.email === '') {
        return false;
      }
      if (this.avatar === '') {
        return false;
      }
      return true;
    },
    editMode() {
      return this.origData !== undefined;
    },
  },
  methods: {
    changeBranch() {
    },
    handleClose(done) {
      done();
    },
    show() {
      this.drawer = true;
    },
    close(result) {
      this.reset();
      this.drawer = false;
      this.$emit('finish', result);
    },
    loadData(pro) {
      this.origData = pro;

      // eslint-disable-next-line prefer-destructuring
      this.familyName = this.origData.family_name;
      this.givenName = this.origData.given_name;
      this.email = this.origData.email;
      this.position = this.origData.title;
      this.avatar = this.origData.avatar.id;
      this.avatarPreview = this.origData.avatar.url;
      // 帶入既有簽名檔 id，未重新上傳時才不會被後端以 None 覆寫而清空
      this.signature = this.origData.signature?.id || '';
      this.signaturePreview = this.origData.signature?.url || '';
      this.branch = undefined;
      this.$nextTick(() => {
        const ids = this.origData.branches.map((b) => b.id);
        if (ids.length > 0) {
          [this.branch] = ids;
        }
      });
    },
    upload() {
      this.$refs.upload.click();
    },
    async changeFile() {
      if (this.$refs.upload.files.length < 1) {
        return;
      }
      this.$execWithLoading(async () => {
        const file = this.$refs.upload.files[0];
        const rsp = await createAvatar(file);
        this.avatar = rsp.id;
        this.file = file;
        this.avatarPreview = URL.createObjectURL(file);
      }, (e) => this.$showAxiosException('上傳頭像失敗', e));
    },
    removeAvatar() {
      this.avatarPreview = '';
      this.file = undefined;
      if (this.$refs.upload) {
        this.$refs.upload.value = '';
      }
    },
    uploadSignature() {
      this.$refs.uploadSignatureInput.click();
    },
    async changeSignature() {
      if (this.$refs.uploadSignatureInput.files.length < 1) {
        return;
      }
      this.$execWithLoading(async () => {
        const file = this.$refs.uploadSignatureInput.files[0];
        const rsp = await createSignature(file);
        this.signature = rsp.id;
        this.signatureFile = file;
        this.signaturePreview = URL.createObjectURL(file);
      }, (e) => this.$showAxiosException('上傳簽名檔失敗', e));
    },
    removeSignature() {
      this.signature = '';
      this.signaturePreview = '';
      this.signatureFile = undefined;
      if (this.$refs.uploadSignatureInput) {
        this.$refs.uploadSignatureInput.value = '';
      }
    },
    reset() {
      this.origData = undefined;
      this.drawer = false;
      this.familyName = '';
      this.givenName = '';
      this.email = '';
      this.position = '';
      this.avatar = '';
      this.branch = undefined;
      this.removeAvatar();
      this.removeSignature();
    },
    cancel() {
      this.close(false);
    },
    save() {
      this.$execWithLoading(async () => {
        if (this.editMode) {
          await updateProfessional(
            this.origData.id,
            this.familyName,
            this.givenName,
            this.email,
            this.avatar,
            true,
            this.position,
            [this.branch],
            this.signature,
          );
          this.$showSuccess('更新成功');
          this.close(true);
        } else {
          await newProfessional(
            this.familyName,
            this.givenName,
            this.email,
            this.avatar,
            true,
            this.position,
            [this.branch],
            this.signature,
          );
          this.$showSuccess('新增成功');
          this.close(true);
        }
      }, (e) => {
        if (this.editMode) {
          this.$showAxiosException('更新失敗', e);
        } else {
          this.$showAxiosException('新增失敗', e);
        }
      });
    },
    async updateStatus(status) {
      let msg = '停用此帳號，專業人士將不能登入帳戶';
      let alertMsg = '此帳號已停用';
      if (status) {
        msg = '啟用此帳號，專業人士需重新完成雙重驗證';
        alertMsg = '此帳號已啟用';
      }
      try {
        await this.$confirm(msg, '提醒', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning',
        });
      } catch (e) {
        return;
      }
      this.$execWithLoading(async () => {
        await updateProfessionalStatus(this.origData.id, status);
        this.origData.enabled = status;
        if (!status) {
          this.origData.public = false;
        }
        this.$forceUpdate();
        this.$showSuccess(alertMsg);
      }, (e) => this.$showAxiosException(status ? '啟用帳號失敗' : '停用帳號失敗', e));
    },
  },
  mounted() {
    this.$on('show', (data) => {
      this.reset();
      if (data) {
        this.loadData(data);
      }
      this.show();
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.drawer {
  padding: 20px;
  .button {
    flex: 1;
  }
  img {
    width: 80px;
    height: 80px;
    object-fit: cover;
    &.preview-signature {
      width: 120px;
      height: auto;
    }
  }
  input[type=file] {
    display: none;
  }
  .preview {
    .remove-icon {
      color: $danger-color;
      width: 13px;
      height: 13px;
      border-radius: 100%;
      border: 1px solid $danger-color;
      i {
        zoom: 0.6;
      }
    }
  }
}
</style>
